import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../analytics/utils/firebaseUtils'
import Button from '../components/actions/Button'
import { ModalContext } from '../contexts/ModalContext'
import ModalWrapper from '../wrappers/modalWrapper/ModalWrapper'

interface ContractConfirmationModalProps {}

const ContractConfirmationModal: React.FC<ContractConfirmationModalProps> = () => {
	const { t } = useTranslation('pages_contractConfirmation')
	const { t: tc } = useTranslation('pages_contactSupport')

	const { clearModals } = useContext(ModalContext)

	const onClose = () => {
		logEvent('click-generic-cancel')
		clearModals()
	}

	const onClickEmail = () => {
		logEvent('click-support-email')
	}

	const onClickPhoneNumber = () => {
		logEvent('click-support-phone')
	}

	return (
		<ModalWrapper>
			<div className='container text-text-grey-200 dark:text-text-grey-100'>
				<span className='title text-text-dark dark:text-white'>{t('title')}</span>
				<span>{t('confirmationSent')}</span>

				<span>{t('confirmationSentDesc')}</span>

				<span className='sub-title text-text-dark dark:text-white'>{t('moveInTitle')}</span>
				<span>{t('moveInDesc1')}</span>
				<span>{t('moveInDesc2')}</span>
				<span>{t('moveInDesc3')}</span>

				<span className='sub-title text-text-dark dark:text-white'>
					{t('contractCancellationTitle')}
				</span>

				<span className='sub-title text-text-dark dark:text-white'>{t('supportTitle')}</span>
				<span>{t('supportDecs')}</span>
				<span>{t('supportOpen')}</span>
				<div className='support'>
					<span>
						{tc('email')}
						<a onClickCapture={onClickEmail} href={`mailto:${tc('supportEmail')}`}>
							{tc('supportEmail')}
						</a>
					</span>
					<span>
						{tc('phone')}
						<a onClickCapture={onClickPhoneNumber} href={`tel:${tc('supportNumber')}`}>
							{tc('supportNumber')}
						</a>
					</span>
				</div>

				<Button onClick={onClose}>{t('close')}</Button>
			</div>
		</ModalWrapper>
	)
}

export default ContractConfirmationModal
